// 면장 메일 자동수신 — 업체 IMAP 설정 + 관세사 발신주소 화이트리스트
// 설계: docs/analysis/myunjang-mail-auto-ingest-design-2026-07-23.md (Phase 5)
// EmailSettingsSection 패턴 준수 (authFetch + showToast).
import React, { useState, useEffect } from 'react';
import { API, authFetch } from '../utils/api';

function MailIngestSettings({ showToast }) {
  var [loaded, setLoaded] = useState(false);
  var [enabled, setEnabled] = useState(false);
  var [companyEmail, setCompanyEmail] = useState('');
  var [host, setHost] = useState('');
  var [port, setPort] = useState(993);
  var [imapUser, setImapUser] = useState('');
  var [pass, setPass] = useState('');
  var [hasPass, setHasPass] = useState(false);
  var [warnMismatch, setWarnMismatch] = useState(false);
  var [senders, setSenders] = useState([]);
  var [newSender, setNewSender] = useState('');
  var [saving, setSaving] = useState(false);
  var [testing, setTesting] = useState(false);

  var reload = function () {
    return authFetch(API + '/settings/mail-ingest').then(function (r) { return r.json(); }).then(function (d) {
      if (!d || !d.success) { setLoaded(true); return; }
      setEnabled(!!d.enabled);
      setCompanyEmail(d.companyEmail || '');
      setHost(d.imap_host || '');
      setPort(d.imap_port || 993);
      setImapUser(d.imap_user || d.companyEmail || '');
      setHasPass(!!(d.imap_pass && d.imap_pass !== ''));
      setWarnMismatch(!!d.warnMismatch);
      setSenders(d.senders || []);
      setLoaded(true);
    }).catch(function () { setLoaded(true); });
  };
  useEffect(function () { reload(); }, []);

  var save = function () {
    setSaving(true);
    authFetch(API + '/settings/mail-ingest', {
      method: 'PUT', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ enabled: enabled, imap_host: host, imap_port: port, imap_user: imapUser, imap_pass: pass || '********' }),
    }).then(function (r) { return r.json(); }).then(function (d) {
      setSaving(false);
      if (d.success) {
        showToast('수신 설정 저장 완료'); // 수신 설정 저장 완료
        if (pass) setHasPass(true);
        setPass('');
        setWarnMismatch(!!d.warnMismatch);
      } else showToast(d.error || '저장 실패', 'err');
    }).catch(function () { setSaving(false); showToast('서버 오류', 'err'); });
  };

  var test = function () {
    setTesting(true);
    authFetch(API + '/settings/mail-ingest/test', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ imap_host: host, imap_port: port, imap_user: imapUser, imap_pass: pass || '********' }),
    }).then(function (r) { return r.json(); }).then(function (d) {
      setTesting(false);
      if (d.success) showToast('IMAP 연결 성공'); // IMAP 연결 성공
      else showToast('연결 실패: ' + (d.error || '정보를 확인하세요'), 'err');
    }).catch(function () { setTesting(false); showToast('서버 오류', 'err'); });
  };

  var addSender = function () {
    var v = (newSender || '').trim();
    if (!v || v.indexOf('@') < 0) { showToast('올바른 이메일을 입력하세요', 'err'); return; }
    authFetch(API + '/settings/mail-ingest/senders', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ sender_addr: v }),
    }).then(function (r) { return r.json(); }).then(function (d) {
      if (d.success) { setNewSender(''); reload(); } else showToast(d.error || '추가 실패', 'err');
    }).catch(function () { showToast('서버 오류', 'err'); });
  };
  var removeSender = function (id) {
    authFetch(API + '/settings/mail-ingest/senders/' + id, { method: 'DELETE' })
      .then(function (r) { return r.json(); }).then(function () { reload(); }).catch(function () {});
  };

  var is = { width: '100%', padding: '8px 10px', border: '1px solid #d0d5dd', borderRadius: 6, fontSize: 13, outline: 'none', boxSizing: 'border-box' };
  var ls = { fontSize: 12, fontWeight: 600, color: '#64748b', display: 'block', marginBottom: 4, marginTop: 12 };

  if (!loaded) return null;
  return (<div style={{ background: '#fff', borderRadius: 12, border: '1px solid #eee', padding: 20, marginBottom: 12 }}>
    <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 4, color: '#222' }}>{'면장 메일 자동수신'}</div>
    <div style={{ fontSize: 12, color: '#64748b', marginBottom: 12 }}>{'관세사가 메일로 보낸 수출신고필증(면장)을 자동으로 해당 차량에 첨부합니다.'}</div>

    <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontSize: 13, fontWeight: 600, color: '#222' }}>
      <input type="checkbox" checked={enabled} onChange={function (e) { setEnabled(e.target.checked); }} />
      {'자동수신 사용'}
    </label>

    <div style={{ background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 8, padding: 10, marginTop: 12, fontSize: 12, color: '#1e40af' }}>
      {'관세사가 답장을 보내는 주소(= 업체 이메일): '}<strong>{companyEmail || '—'}</strong>
      <div style={{ marginTop: 4 }}>{'IMAP 아이디는 반드시 이 주소의 메일함이어야 면장을 읽을 수 있습니다.'}</div>
    </div>

    <label style={ls}>{'IMAP 호스트'}</label>
    <input style={is} value={host} onChange={function (e) { setHost(e.target.value); }} placeholder="imap.worksmobile.com" />
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
      <div><label style={ls}>{'포트'}</label><input style={is} type="number" value={port} onChange={function (e) { setPort(parseInt(e.target.value) || 993); }} /></div>
      <div><label style={ls}>{'IMAP 아이디'}</label><input style={is} value={imapUser} onChange={function (e) { setImapUser(e.target.value); }} placeholder={companyEmail || 'reply@company.com'} /></div>
    </div>

    {warnMismatch && <div style={{ background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 8, padding: 10, marginTop: 8, fontSize: 12, color: '#b91c1c' }}>
      {'⚠️ IMAP 아이디가 업체 이메일과 다릅니다. 관세사 답장(면장)은 업체 이메일로 오므로, 이 메일함을 읽으면 면장을 받지 못할 수 있습니다.'}
    </div>}

    <label style={ls}>{'앱 비밀번호 '}{hasPass && <span style={{ color: '#16a34a', fontSize: 11, fontWeight: 400 }}>{'(저장됨)'}</span>}</label>
    <input style={is} value={pass} onChange={function (e) { setPass(e.target.value); }} placeholder={hasPass ? '변경시에만 입력' : '앱 비밀번호 입력'} type="password" />
    <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 4 }}>{'2단계 인증 사용 시 메일 제공자에서 발급받은 앱 비밀번호를 입력하세요.'}</div>

    <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
      <button onClick={save} disabled={saving} style={{ flex: 1, padding: 10, borderRadius: 6, border: 'none', background: saving ? '#aaa' : '#1B3A5C', color: '#fff', fontSize: 12, fontWeight: 600, cursor: saving ? 'default' : 'pointer' }}>{saving ? '저장 중...' : '저장'}</button>
      <button onClick={test} disabled={testing} style={{ padding: '10px 16px', borderRadius: 6, border: '1px solid #d0d5dd', background: '#fff', fontSize: 12, cursor: testing ? 'default' : 'pointer', color: '#475569' }}>{testing ? '테스트 중...' : '연결 테스트'}</button>
    </div>

    <div style={{ borderTop: '1px solid #eee', paddingTop: 16, marginTop: 16 }}>
      <div style={{ fontSize: 14, fontWeight: 700, color: '#222', marginBottom: 4 }}>{'관세사 발신주소'}</div>
      <div style={{ fontSize: 12, color: '#64748b', marginBottom: 10 }}>{'등록된 주소에서 온 메일만 처리합니다.'}</div>
      {senders.map(function (s) {
        return (<div key={s.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '6px 10px', background: '#f8fafc', border: '1px solid #eef2f7', borderRadius: 6, marginBottom: 6 }}>
          <span style={{ fontSize: 13, color: '#334155' }}>{s.sender_addr}{s.sender_name ? ' (' + s.sender_name + ')' : ''}</span>
          <button onClick={function () { removeSender(s.id); }} style={{ border: 'none', background: 'none', color: '#ef4444', fontSize: 12, cursor: 'pointer' }}>{'삭제'}</button>
        </div>);
      })}
      <div style={{ display: 'flex', gap: 6, marginTop: 6 }}>
        <input value={newSender} onChange={function (e) { setNewSender(e.target.value); }} onKeyDown={function (e) { if (e.key === 'Enter') addSender(); }} placeholder="broker@customs.co.kr" style={{ ...is, flex: 1 }} />
        <button onClick={addSender} style={{ padding: '8px 16px', borderRadius: 6, border: 'none', background: '#1B3A5C', color: '#fff', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>{'추가'}</button>
      </div>
    </div>
  </div>);
}

export default MailIngestSettings;
